import * as React from "react";
const USBasedTeamSupportSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#fff" rx={24} />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#FDECEB"
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EE4137"
      d="M36.082 19.978a11.313 11.313 0 0 0-7.996-3.353H28A11.375 11.375 0 0 0 16.625 28v6.125a2.625 2.625 0 0 0 2.625 2.625H21a2.625 2.625 0 0 0 2.625-2.625V29.75A2.625 2.625 0 0 0 21 27.125h-2.586a9.638 9.638 0 0 1 16.426-5.914 9.558 9.558 0 0 1 2.747 5.914H35a2.625 2.625 0 0 0-2.625 2.625v4.375A2.625 2.625 0 0 0 35 36.75h2.625A2.625 2.625 0 0 1 35 39.375h-6.125a.875.875 0 1 0 0 1.75H35a4.375 4.375 0 0 0 4.375-4.375V28a11.31 11.31 0 0 0-3.293-8.022ZM21 28.875a.875.875 0 0 1 .875.875v4.375A.875.875 0 0 1 21 35h-1.75a.875.875 0 0 1-.875-.875v-5.25H21ZM35 35a.875.875 0 0 1-.875-.875V29.75a.875.875 0 0 1 .875-.875h2.625V35H35Z"
    />
  </svg>
);
export default USBasedTeamSupportSVG;
